(() => {
  const init = root => {
    if (root.dataset.tshReady) return;
    root.dataset.tshReady = 'true';
    // Only supply an H1 on the home page when the page has none already.
    // Other page templates keep their own product/collection headings.
    const homePath = (window.Shopify?.routes?.root || '/').replace(/\/+$/, '') || '/';
    const pagePath = location.pathname.replace(/\/+$/, '') || '/';
    const brand = root.querySelector('a.tsh-brand');
    if (pagePath === homePath && !document.querySelector('h1') && brand) {
      const heading = document.createElement('h1');
      heading.className = 'tsh-brand tsh-brand-heading';
      brand.classList.remove('tsh-brand');
      brand.replaceWith(heading);
      heading.appendChild(brand);
    }

    const $ = selector => root.querySelector(selector);
    const $$ = selector => [...root.querySelectorAll(selector)];
    const focusable = area => [...area.querySelectorAll('a[href],summary,button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(el => el.getClientRects().length);
    const buttons = $$('[data-tsh-menu]');
    const panelFor = button => $(`#${button.dataset.tshMenu}`);
    const triggerFor = button => button.closest('.tsh-department-nav-item') || button;
    const panels = buttons.map(panelFor).filter(Boolean);
    let active = null, source = '', timer, mobileOpen = false, returnFocus = null, priorOverflow = '';
    const closeMenus = restore => {
      clearTimeout(timer); const previous = active;
      buttons.forEach(button => button.setAttribute('aria-expanded','false'));
      panels.forEach(panel => panel.hidden = true);
      active = null; source = '';
      if (restore) previous?.focus();
    };
    const openMenu = (button, mode) => {
      const panel = panelFor(button); if (!panel) return;
      clearTimeout(timer);
      buttons.forEach(other => other.setAttribute('aria-expanded',String(other === button)));
      panels.forEach(other => other.hidden = other !== panel);
      active = button; source = mode;
    };
    const scheduleClose = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (!buttons.includes(document.activeElement) && !panels.some(panel => panel.contains(document.activeElement))) closeMenus(false);
      }, 180);
    };
    buttons.forEach(button => {
      const panel = panelFor(button); if (!panel) return;
      button.addEventListener('click', () => active === button && source === 'click' ? closeMenus(false) : openMenu(button,'click'));
      const trigger = triggerFor(button);
      trigger.addEventListener('mouseenter', () => { if (matchMedia('(hover:hover)').matches) openMenu(button,'hover'); });
      trigger.addEventListener('mouseleave',scheduleClose);
      button.addEventListener('keydown', event => {
        if (['ArrowDown','ArrowUp'].includes(event.key)) {
          event.preventDefault();openMenu(button,'keyboard');
          const links=focusable(panel);(event.key === 'ArrowUp' ? links.at(-1) : links[0])?.focus();
        }
      });
      panel.addEventListener('mouseenter',()=>clearTimeout(timer));
      panel.addEventListener('mouseleave',scheduleClose);
    });
    const toggle=$('#tsh-menu-toggle'), close=$('#tsh-menu-close'), mobile=$('#tsh-mobile-menu'), backdrop=$('#tsh-mobile-backdrop');
    const closeMobile = (restore=true) => {
      if (!mobileOpen) return;
      mobileOpen=false;mobile.hidden=true;backdrop.hidden=true;
      toggle.setAttribute('aria-expanded','false');document.body.style.overflow=priorOverflow;
      if (restore) (returnFocus||toggle)?.focus();
    };
    const openMobile = () => {
      returnFocus=document.activeElement;closeMenus(false);mobileOpen=true;
      mobile.hidden=false;backdrop.hidden=false;mobile.setAttribute('role','dialog');mobile.setAttribute('aria-modal','true');
      toggle.setAttribute('aria-expanded','true');priorOverflow=document.body.style.overflow;document.body.style.overflow='hidden';close.focus();
    };
    toggle.addEventListener('click',()=>mobileOpen ? closeMobile() : openMobile());
    close.addEventListener('click',()=>closeMobile());
    backdrop.addEventListener('click',()=>closeMobile());
    mobile.addEventListener('click',event=>{if(event.target.closest('a[href]'))closeMobile(false);});
    mobile.addEventListener('keydown',event=>{
      if(event.key==='Escape'){event.preventDefault();closeMobile();return;}
      if(event.key!=='Tab')return;
      const items=focusable(mobile),first=items[0],last=items.at(-1);
      if(event.shiftKey && document.activeElement===first){event.preventDefault();last?.focus();}
      else if(!event.shiftKey && document.activeElement===last){event.preventDefault();first?.focus();}
    });
    document.addEventListener('keydown',event=>{if(event.key==='Escape' && active)closeMenus(true);});
    document.addEventListener('click',event=>{if(!buttons.some(x=>x.contains(event.target))&&!panels.some(x=>x.contains(event.target)))closeMenus(false);});
    document.addEventListener('focusin',event=>{if(!buttons.includes(event.target)&&!panels.some(x=>x.contains(event.target)))closeMenus(false);});
    window.addEventListener('resize',()=>{if(innerWidth>1100 && mobileOpen)closeMobile(false);});
    // Shopify predictive product search, scoped to this header.
    const searchWrap = $('.tsh-search-wrap');
    const searchForm = $('#tsh-site-search-form');
    const searchInput = $('#tsh-site-search');
    const searchPanel = $('#tsh-search-suggestions');
    const searchOptions = $('#tsh-search-options');
    const searchMessage = $('#tsh-search-message');
    const searchLive = $('#tsh-search-live');
    const searchBase = new URL(window.Shopify?.routes?.root || '/', location.origin);
    searchForm.action = new URL('search', searchBase).href;
    const resultCache = new Map();
    let searchTimer, searchController, searchRequest = 0, activeResult = -1;
    const searchLinks = () => [...searchOptions.querySelectorAll('[role="option"]')];
    const cancelSearch = () => {
      clearTimeout(searchTimer);
      searchRequest += 1;
      searchController?.abort();
      searchController = null;
    };
    const resetSelection = () => {
      activeResult = -1;
      searchInput.removeAttribute('aria-activedescendant');
      searchLinks().forEach(link => link.setAttribute('aria-selected','false'));
    };
    const closeSearch = () => {
      cancelSearch();
      searchPanel.hidden = true;
      searchInput.setAttribute('aria-expanded','false');
      searchOptions.removeAttribute('aria-busy');
      searchLive.textContent = '';
      resetSelection();
    };
    const openSearch = () => {
      closeMenus(false);
      searchPanel.hidden = false;
      searchInput.setAttribute('aria-expanded','true');
    };
    const allResultsURL = query => {
      const url = new URL('search',searchBase);
      url.searchParams.set('q',query);
      url.searchParams.set('type','product');
      return url.href;
    };
    const addAllResults = query => {
      const link = document.createElement('a');
      link.id = 'tsh-search-view-all';
      link.className = 'tsh-search-view-all';
      link.href = allResultsURL(query);
      link.setAttribute('role','option');
      link.setAttribute('aria-selected','false');
      link.tabIndex = -1;
      link.textContent = 'View all results for “' + query + '” →';
      searchOptions.appendChild(link);
    };
    const showSearchMessage = (message, query, busy = false) => {
      resetSelection();
      searchOptions.replaceChildren();
      searchMessage.hidden = false;
      searchMessage.textContent = message;
      searchLive.textContent = message;
      searchOptions.setAttribute('aria-busy',String(busy));
      if (!busy) addAllResults(query);
      openSearch();
    };
    const formatPrice = product => {
      // The Predictive Search API returns decimal prices, not integer cents.
      const raw = product.price_min ?? product.price;
      if (raw == null || raw === '' || !Number.isFinite(Number(raw))) return '';
      const amount = Number(raw);
      const currency = window.Shopify?.currency?.active || 'USD';
      let price;
      try { price = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency}).format(amount); }
      catch (_) { price = amount.toFixed(2) + ' ' + currency; }
      return (Number(product.price_max) > amount ? 'From ' : '') + price;
    };
    const safeURL = value => {
      try {
        const url = new URL(value, searchBase);
        return ['https:','http:'].includes(url.protocol) ? url.href : null;
      } catch (_) { return null; }
    };
    const renderSearchResults = (products,query) => {
      resetSelection();
      searchOptions.replaceChildren();
      searchMessage.hidden = true;
      searchOptions.setAttribute('aria-busy','false');
      let count = 0;
      products.slice(0,6).forEach(product => {
        const href = product.url && safeURL(product.url);
        if (!href || !product.title) return;
        const link = document.createElement('a');
        link.className = 'tsh-search-result';
        link.id = 'tsh-search-result-' + count++;
        link.href = href;
        link.setAttribute('role','option');
        link.setAttribute('aria-selected','false');
        link.tabIndex = -1;
        const thumb = document.createElement('span');
        thumb.className = 'tsh-search-thumb';
        const source = product.featured_image?.url || product.image;
        const imageURL = source && safeURL(source);
        if (imageURL) {
          const img = document.createElement('img');
          img.src = imageURL;
          img.alt = '';
          img.width = 54;
          img.height = 54;
          img.loading = 'lazy';
          img.addEventListener('error',()=>{img.remove();thumb.textContent='—';},{once:true});
          thumb.appendChild(img);
        } else thumb.textContent = '—';
        const info = document.createElement('span');
        info.className = 'tsh-search-result-info';
        const title = document.createElement('span');
        title.className = 'tsh-search-result-title';
        title.textContent = product.title;
        info.appendChild(title);
        const price = document.createElement('span');
        price.className = 'tsh-search-result-price';
        price.textContent = formatPrice(product);
        if (price.textContent) info.appendChild(price);
        link.append(thumb,info);
        searchOptions.appendChild(link);
      });
      if (!count) {
        searchMessage.hidden = false;
        searchMessage.textContent = 'No suggested products. Try another term or view all results.';
      }
      addAllResults(query);
      searchLive.textContent = count ? count + ' product suggestions. Use the up and down arrows to browse.' : 'No product suggestions.';
      openSearch();
      const first = searchOptions.querySelector('.tsh-search-result');
      if (first) document.dispatchEvent(new CustomEvent('ts:search-target', {detail: {link: first, selected: false}}));
    };
    const loadSearchResults = async query => {
      if (!root.isConnected || document.activeElement !== searchInput || searchInput.value.trim() !== query) return;
      const request = ++searchRequest;
      const controller = new AbortController();
      searchController = controller;
      const timeout = setTimeout(()=>controller.abort(),7000);
      const url = new URL('search/suggest.json',searchBase);
      url.searchParams.set('q',query);
      url.searchParams.set('resources[type]','product');
      url.searchParams.set('resources[limit]','6');
      url.searchParams.set('resources[options][unavailable_products]','last');
      try {
        const response = await fetch(url.href,{signal:controller.signal,credentials:'same-origin',headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error('Predictive search unavailable');
        const data = await response.json();
        const products = data?.resources?.results?.products;
        if (!Array.isArray(products)) throw new Error('Invalid predictive search response');
        if (request !== searchRequest || searchInput.value.trim() !== query || document.activeElement !== searchInput || !root.isConnected) return;
        if (resultCache.size >= 20) resultCache.delete(resultCache.keys().next().value);
        resultCache.set(query,products);
        renderSearchResults(products,query);
      } catch (_) {
        if (request === searchRequest && searchInput.value.trim() === query && document.activeElement === searchInput && root.isConnected) {
          showSearchMessage('Suggestions are unavailable. Press Enter to search.',query);
        }
      } finally {
        clearTimeout(timeout);
        if (searchController === controller) searchController = null;
      }
    };
    const queueSearch = () => {
      cancelSearch();
      const query = searchInput.value.trim();
      if (query.length < 2) { closeSearch(); return; }
      if (resultCache.has(query)) { renderSearchResults(resultCache.get(query),query); return; }
      showSearchMessage('Searching products…',query,true);
      searchTimer = setTimeout(()=>loadSearchResults(query),220);
    };
    let searchComposing = false;
    searchInput.addEventListener('compositionstart',()=>{searchComposing=true;closeSearch();});
    searchInput.addEventListener('compositionend',()=>{searchComposing=false;queueSearch();});
    searchInput.addEventListener('input',()=>{if(!searchComposing)queueSearch();});
    searchInput.addEventListener('focus',()=>{if(!searchComposing)queueSearch();});
    searchInput.addEventListener('keydown',event=>{
      if (event.isComposing || searchComposing) return;
      if (event.key === 'Escape') { event.preventDefault();closeSearch();return; }
      if (event.key === 'Tab') { closeSearch();return; }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        const links = searchLinks();
        if (searchPanel.hidden) { queueSearch();return; }
        if (!links.length) return;
        event.preventDefault();
        activeResult = event.key === 'ArrowDown' ? (activeResult+1)%links.length : (activeResult<=0 ? links.length-1 : activeResult-1);
        links.forEach((link,index)=>link.setAttribute('aria-selected',String(index===activeResult)));
        searchInput.setAttribute('aria-activedescendant',links[activeResult].id);
        links[activeResult].scrollIntoView({block:'nearest'});
        document.dispatchEvent(new CustomEvent('ts:search-target', {detail: {link: links[activeResult], selected: true}}));
      } else if (event.key === 'Enter' && !searchPanel.hidden && activeResult >= 0) {
        const link = searchLinks()[activeResult];
        if (link) {event.preventDefault();link.click();}
      }
    });
    $('#tsh-search-close').addEventListener('click',()=>{
      searchInput.focus();
      closeSearch();
    });
    document.addEventListener('pointerdown',event=>{if(!searchWrap.contains(event.target))closeSearch();});
    document.addEventListener('focusin',event=>{if(!searchWrap.contains(event.target))closeSearch();});
    buttons.forEach(button=>triggerFor(button).addEventListener('mouseenter',closeSearch));
    toggle.addEventListener('click',closeSearch);
    searchForm.addEventListener('submit',event=>{
      searchInput.value=searchInput.value.trim();
      if(!searchInput.value){event.preventDefault();searchInput.focus();}
      closeSearch();
    });

  };
  const start = () => document.querySelectorAll('[data-tsh-root]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',start);
})();
